/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmTokenSummaryInfo } from './EvmTokenSummaryInfo';

export type KiteTokenDetailInfo = {
    TKNSMR: EvmTokenSummaryInfo;
    HD: string;
    TSP: string;
    PRC: string;
    MKC: string;
    VOL24H: string;
    HD24H: string;
    TTCNT: string;
    DPL: string;
    CTRXHA: string;
    TKNT: KiteTokenDetailInfo.TKNT;
    DCML: string;
};

export namespace KiteTokenDetailInfo {

    export enum TKNT {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }


}

